import isEmpty from 'lodash-es/isEmpty';

import { environment as ENV } from '@environment';
import { BookingBillingDocumentRules } from '@app/entities/booking-documents';

export function isValidBilligByConfigModule(
  country: string, validations: BookingBillingDocumentRules
): boolean {
  if (country && !isEmpty(validations)) {
    if (validations.LOCAL_NATIONALITY && validations.FOREIGN_NATIONALITY) {
      return true;
    } else if (validations.LOCAL_NATIONALITY) {
      return country === ENV.countryInfo.iso_code;
    } else if (validations.FOREIGN_NATIONALITY) {
      return country !== ENV.countryInfo.iso_code;
    } else return true;
  } else return true;
}
